import React, { Component } from 'react';
import data from '../../assets/json/about.json';

export default class Experience extends Component {

  state = {
    window: 'desktop'
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
    this.resize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    if(window.innerWidth > 650) {
      this.setState({
        window: 'desktop'
      })
    }
    else {
      this.setState({
        window: 'mobile'
      })
    }
  }

  experienceStyle = () => {
    if(window.innerWidth > 650) {
      return { height: `${(((data.experience.length + 1) * 196) + 344) + 200}px` }
    }
    else {
      return { height: `${(((data.experience.length + 1) * 196) + 344) + 100}px` }
    }
  }

  lineStyle = () => {
    if(window.innerWidth > 650) {
      return {
        height: `${(data.experience.length + 1) * 196}px`,
        top: '344px'
      }
    }
    else {
      return {
        height: `${(data.experience.length + 1) * 196}px`,
        top: '224px'
      }
    }
  };

  startStyle = () => {
    if(window.innerWidth > 650) {
      return { top: `${((data.experience.length + 1) * 196) + 344}px` }
    }
    else {
      return { top: `${((data.experience.length + 1) * 196) + 224}px` }
    }
  }

  render() {
    return (
      <div className="experience" style={this.experienceStyle()}>
        <div className="experience-timeline">
          <div className="experience-circle timeline-top">
            <div className="experience-circle timeline-top-middle">
              <div className="experience-circle timeline-top-inner">
                <span className="title">Experience</span>
              </div>
            </div>
            <div className="timeline-line" style={this.lineStyle()}></div>
            <div className="timeline-start" style={this.startStyle()}></div>
          </div>

          {
            data.experience.map(({company, date_from, date_to, website, description}) => (
              <div className="timeline-item" key={company}>
                <div className="dates">
                  <span className="timeline-date">{date_from} -</span>
                  <span className="timeline-date">{date_to}</span>
                </div>
                <div className="experience-circle timeline-inner">
                  <div className="experience-circle timeline-inner-middle">
                    <div className="experience-circle timeline-inner-inner">
                    </div>
                  </div>
                </div>
                <div className="timeline-desc">
                  <span>{company}</span>
                  {
                    this.state.window === 'mobile' &&
                    <span>{date_from} -</span>
                  }
                  <span>{ this.state.window === 'desktop' ? description : date_to }</span>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/home/Experience.js